import createCachedSelector from 're-reselect'
import { State } from '../../reducers'
import type { DashboardUser } from '../../../schema/user'
import { canTypeCompanyNameList } from '../../../components/vacature/[id]/utils'
import { COMPANY_TYPE_DIRECT_EMPLOYER, COMPANY_TYPE_HUMAN_RESOURCE_MANAGER, COMPANY_TYPE_MEDIABUREAU } from '../../constants'

export const canTypeCompanyDisplayName = (user: DashboardUser): boolean => !user.isVerified || (user.company
  && canTypeCompanyNameList
    .map(_ => _.toLowerCase())
    .includes(user.company.companyType.toLowerCase()))

const canTypeAlternativeContactInfoLowerCaseList = [
  COMPANY_TYPE_MEDIABUREAU,
  COMPANY_TYPE_HUMAN_RESOURCE_MANAGER,
  COMPANY_TYPE_DIRECT_EMPLOYER,
].map(name => name.toLowerCase())

export const canTypeAlternativeContactInfo = (user: DashboardUser): boolean => user.company
  && canTypeAlternativeContactInfoLowerCaseList
    .includes(user.company.companyType.toLowerCase())

export const canUserTypeCompanyDisplayName = createCachedSelector(
  (state: State): DashboardUser => state.user,
  canTypeCompanyDisplayName
)(() => 'nocache')

export const canUserTypeAlternativeContactInfo = createCachedSelector(
  (user: DashboardUser): DashboardUser => user,
  canTypeAlternativeContactInfo
)(() => 'nocache')

// istanbul ignore next
export const selectUser = (state: State): DashboardUser => state.user
